document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".menu-item");
  const sections = document.querySelectorAll(".help-center-section");

  const categoryLinks = document.querySelectorAll(".category-item a");
  const blogLinks = document.querySelectorAll(".blog-posts a");
  const menuLinks = document.querySelectorAll(".menu-item a");
  const closeButtons = document.querySelectorAll(".closePopup");

  closeButtons.forEach((close) => {
    close.addEventListener("click", function (e) {
      e.preventDefault();
      document.querySelector(".dynamic-content-wrapper")?.classList.remove("active");
      document.getElementById("dynamicContentOverlay")?.classList.remove("active");
    });
  });
  

  categoryLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const url = this.getAttribute("href");
      loadDynamicContentFromURL(url);
    });
  });

  blogLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      const url = this.getAttribute("href");
      loadDynamicContentFromURL(url);
    });
  });

  menuLinks.forEach((link) => {
    link.addEventListener("click", function (e) {
      menuItems.forEach((item) => item.classList.remove("active"));
      e.preventDefault();
      const url = this.getAttribute("href");
      const parentTtem = this.closest(".menu-item");
      parentTtem.classList.add("active");
      loadDynamicContentFromURL(url);
    });
  });

  // get tab from url or first valid tab
  const urlParams = new URLSearchParams(window.location.search);

  // first tab with span[data-tab-title]
  let defaultTabTitle = null;
  for (let item of menuItems) {
    const span = item.querySelector("span[data-tab-title]");
    if (span) {
      defaultTabTitle = span.getAttribute("data-tab-title");
      break;
    }
  }

  let activeTabTitle = urlParams.get("tab") || defaultTabTitle;

  function updateActiveSection(tabTitle) {
    sections.forEach((section) => {
      const parent = section.parentElement;
      if (parent) {
        parent.classList.toggle("hidden-section", section.getAttribute("data-tab") !== tabTitle);
      }
    });
  }

  async function loadDynamicContentFromURL(url = null) {
    const wrapper = document.querySelector(".dynamic-content-wrapper");
    const content = document.getElementById("dynamicContent");
    const overlay = document.getElementById("dynamicContentOverlay");
  
    if (!wrapper || !content || !url) {
      content.innerHTML = '';
      return;
    }

    const loadingText = wrapper.dataset.loading || "Loading...";

    content.innerHTML = `<p style="padding:20px;text-align:center">${loadingText}</p>`;
    wrapper.classList.remove("active");
    wrapper.classList.add("loading");
  
    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
  
      const extracted = doc.querySelector("main") || doc.body;
  
      content.innerHTML = extracted.innerHTML;
  
      wrapper.classList.remove("loading");
      wrapper.classList.add("active");
  
      if (wrapper.classList.contains("popup-mode")) {
        overlay?.classList.add("active");
      } else {
        overlay?.classList.remove("active");
      }
    } catch (err) {
      content.innerHTML = "<p style='padding:20px; color:red;'>Failed to load content.</p>";
      wrapper.classList.remove("loading");
      wrapper.classList.add("active");
    }
  }

  function handleMenuClick(event) {
    event.preventDefault();

    menuItems.forEach((item) => item.classList.remove("active"));

    const clickedItem = event.currentTarget;
    clickedItem.classList.add("active");
    loadDynamicContentFromURL();

    const tabTitle = clickedItem.querySelector("span").getAttribute("data-tab-title");

    // update url without reload page
    const newUrl = new URL(window.location);
    newUrl.searchParams.set("tab", tabTitle);
    window.history.pushState({}, "", newUrl);

    updateActiveSection(tabTitle);

    // Reset search input when switch tab
    resetSearch();
  }

  // set active tab follow URL param (or first tab)
  const activeItem = [...menuItems].find(item => 
    item.querySelector("span")?.getAttribute("data-tab-title") === activeTabTitle
  );
  if (activeItem) {
    activeItem.classList.add("active");
    updateActiveSection(activeTabTitle);
  }

  menuItems.forEach((item) => {
    if (item.querySelector("span")) {
      item.addEventListener("click", handleMenuClick);
    }    
  });

  window.addEventListener("popstate", function () {
    const newParams = new URLSearchParams(window.location.search);
    const newTab = newParams.get("tab") || menuItems[0]?.querySelector("span").getAttribute("data-tab-title");
    
    updateActiveSection(newTab);
    
    menuItems.forEach((item) => item.classList.remove("active"));
    const newActiveItem = [...menuItems].find(item => 
      item.querySelector("span").getAttribute("data-tab-title") === newTab
    );
    if (newActiveItem) {
      newActiveItem.classList.add("active");
    }
    
    // Reset search search input when Back/Forward
    resetSearch();
  });

  function resetSearch() {
    const searchInput = document.querySelector(".custom-search-section .search-input");
    if (!searchInput) return;
    searchInput.value = "";
    searchInput.dispatchEvent(new Event("input"));
  }

  const searchInput = document.querySelector(".custom-search-section .search-input");

  if (!searchInput) return;

  searchInput.addEventListener("input", function () {
    const query = searchInput.value.trim().toLowerCase();
    const helpCenterSections = document.querySelectorAll(".help-center-tab:not(.hidden-section)");

    loadDynamicContentFromURL();

    if (!helpCenterSections.length) return;

    searchInput.classList.add("loading");

    // Reset previous search state: remove filtered & active/no-data class
    helpCenterSections.forEach((section) => {
      section.classList.remove("filtered");
      section.querySelectorAll(".active, .no-data").forEach((el) => el.classList.remove("active", "no-data"));
    });

    helpCenterSections.forEach((section) => {
      let blogFound = false;
      let faqFound = false;
      let categoryFound = false;

      // Search in blog posts
      const blogContainer = section.querySelector(".articles");
      if (blogContainer) {
        blogContainer.classList.remove("no-data");
        blogContainer.querySelectorAll(".columns").forEach((post) => {
          const title = (post.querySelector(".blog-post-info a")?.innerHTML || "").trim().toLowerCase();
          const content = (post.querySelector(".post-excerpt p")?.innerHTML || "").trim().toLowerCase();
          if (title.includes(query) || content.includes(query)) {
            post.classList.add("active");
            blogFound = true;
          }
        });
        if (!blogFound) {
          blogContainer.classList.add("no-data");
        }
      }

      // Search in FAQs
      const faqContainer = section.querySelector(".faq-list");
      if (faqContainer) {
        faqContainer.classList.remove("no-data");
        faqContainer.querySelectorAll(".collapsible-content__inner").forEach((faq) => {
          const title = (faq.querySelector("summary")?.innerHTML || "").trim().toLowerCase();
          const content = (faq.querySelector(".collapsible__content")?.innerHTML || "").trim().toLowerCase();
          if (title.includes(query) || content.includes(query)) {
            faq.classList.add("active");
            faqFound = true;
          }
        });
        if (!faqFound) {
          faqContainer.classList.add("no-data");
        }
      }

      // Search in categories
      const categoryContainer = section.querySelector(".category-grid");
      if (categoryContainer) {
        categoryContainer.classList.remove("no-data");
        categoryContainer.querySelectorAll(".category-item").forEach((category) => {
          const title = (category.querySelector(".category-info h3")?.innerHTML || "").trim().toLowerCase();
          const content = (category.querySelector(".category-info p")?.innerHTML || "").trim().toLowerCase();
          if (title.includes(query) || content.includes(query)) {
            category.classList.add("active");
            categoryFound = true;
          }
        });
        if (!categoryFound) {
          categoryContainer.classList.add("no-data");
        }
      }

      section.classList.add("filtered");
    });

    searchInput.classList.remove("loading");
  });
});

